// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { BasketRow } from '../../styled-components/shared';
import { BasketItemStatuses, type BasketItemStatus } from '../../types/basket';
import { type OddsChange } from '../../types/basket';
import BasketBonusListContainer from '../BasketBonusList/BasketBonusListContainer';
import BasketOdds from '../BasketOdds';
import PresetsContainer from '../BasketPresets/BasketPresetsContainer';
import BasketStakeContainer from '../BasketStake/BasketStakeContainer';

type CardOddProps = {
  className?: string;
  status: BasketItemStatus;
  validatedValue?: number;
  value: number;
  changed?: OddsChange;
  flexDirection?: string;
};

const CardOdd = ({ className = '', status, validatedValue, value, changed, flexDirection = 'row' }: CardOddProps) => {
  const isValidatedOddChanged =
    (status === BasketItemStatuses.VALIDATED || status === BasketItemStatuses.PENDING) &&
    !!validatedValue &&
    value !== validatedValue;

  return (
    <BasketOdds
      className={className}
      validatedValue={isValidatedOddChanged ? validatedValue : null}
      value={value}
      changed={changed}
      $noselfspread
      flexDirection={flexDirection}
    />
  );
};

const StyledCardOdd = styled(CardOdd)`
  ${({ $noselfspread }) => css`
    width: ${!$noselfspread ? '100%' : undefined};
    margin-left: ${$noselfspread ? '2em' : undefined};
  `}

  line-height: 0.9;
`;

type BasketCardSimpleContentProps = {
  isBasketSimpleMode: boolean;
  status: BasketItemStatus;
  nbItem: number;
  oddId: number;
  changed?: OddsChange;
  value: number;
  selectedFreebetId: number;
  validatedValue?: number;
};

const BasketCardSimpleContent = ({
  isBasketSimpleMode,
  status,
  nbItem,
  oddId,
  changed,
  value,
  selectedFreebetId,
  validatedValue,
}: BasketCardSimpleContentProps) => {
  return (
    <>
      {isBasketSimpleMode ? (
        <>
          <BasketRow $alignRight={nbItem === 1}>
            {nbItem !== 1 ? <BasketStakeContainer itemId={oddId} selectedFreebetId={selectedFreebetId} /> : null}
            <StyledCardOdd
              $noselfspread
              changed={changed}
              status={status}
              value={value}
              validatedValue={validatedValue}
              flexDirection={nbItem === 1 ? 'row' : 'column'}
            />
          </BasketRow>
          <PresetsContainer itemId={oddId} odds={value} selectedFreebetId={selectedFreebetId} />
        </>
      ) : null}
      <BasketBonusListContainer itemId={oddId} />
    </>
  );
};

export default React.memo<BasketCardSimpleContentProps>(BasketCardSimpleContent);
